const PLStatus = {
  NotOnboarded: "not-onboarded",
  Active: "active",
  Hidden: "hidden",
  Deactivated: "deactivated",
};

export default PLStatus;
